<template>
  <div class="app-main-inner app-main-page push-config">
    <div class="app-main-inner-row">
      <div class="filters">
        <el-form :inline="true" label-width="100px" label-position="right">
          <div class="el-form-item-wrapper">
            <el-form-item label-width="100px" :label="$t('SystemMaintenance.SelectBranch')">
              <el-select v-model="branchId" @change="getRemarkConfigFunc">
                <el-option
                  v-for="office in currentOfficeList"
                  :key="office.uuid"
                  :value="office.officeId"
                  :label="office.code"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <div class="app-el-transfer_page">
      <div align="center">
        <ul>
          <li>{{ $t('SystemMaintenance.Precautions') }}</li>
          <li />
          <li>{{ $t('SystemMaintenance.SavedEffectFromTheInvoice') }}</li>
          <li>{{ $t('SystemMaintenance.EBeLessThanCharacters') }}</li>
          <li>{{ $t('SystemMaintenance.PaperBeLessThanCharacters') }}</li>
          <li>{{ $t('SystemMaintenance.AutomaticallyALineDoesShow') }}</li>
          <li>{{ $t('SystemMaintenance.PDFCanDisplayUpLines') }}</li>
        </ul>
      </div>
      <div class="app-el-transfer" style="width: 100%;display: flex">
        <el-transfer id="transfer" ref="transfer" v-model="transferValue" style="width: 700px" :target-order="'push'" :data="listData" :titles="[$t('SystemMaintenance.Unused'), $t('SystemMaintenance.Used')]">
          <span slot-scope="{ option }" :draggable="!option.disabled" @dragstart="drag($event,option)">
            <label v-if="option.key == 18" class="app-el-transfer-label" :title="$t('SystemMaintenance.Example8180ThisTicketOnlyDollars')">
              {{ option.label }} <img :src="'/static/q.png'" width="12" height="12">
            </label>
            <label v-else class="app-el-transfer-label">
              {{ option.label }}
            </label>
          </span>
        </el-transfer>
        <!-- 添加自定义备注输入框 -->
        <div class="custom-remarks" style="flex: 1">
          <div class="remark-item">
            <div class="remark-label">{{ $t('SystemMaintenance.CustomRemarkOne') }}</div>
            <el-input
              v-model="customRemarkOne"
              type="textarea"
              :maxlength="200"
              :show-word-limit="true"
              :rows="4"
              style="width: 300px"
            />
          </div>
          <div class="remark-item">
            <div class="remark-label">{{ $t('SystemMaintenance.CustomRemarkTwo') }}</div>
            <el-input
              v-model="customRemarkTwo"
              type="textarea"
              :maxlength="200"
              :show-word-limit="true"
              :rows="4"
              style="width: 300px"
            />
          </div>
          <el-checkbox v-model="ifAutoUpdateRemark" style="margin-left: 8px;margin-right: 8px" no="ifAutoUpdateRemark">{{ $t('CargoMsg.Cargo_AutoUpdateNote') }}</el-checkbox>
        </div>
      </div>
      <div class="triggers" align="center">
        <el-button type="primary" @click="saveConfig">
          {{ $t('common.btn.save') }}
        </el-button>

        <el-button type="primary" style="margin-left: 30px;" @click="refreshConfig">
          {{ $t('common.btn.refresh') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { getUserInfo } from '@/utils/auth'
import { getRemarkConfig, saveRemarkConfig, getInitializationConfig } from '@/api/sysManage/baseConfig/diyInvoiceRemark'
import ColumnUtils from '@/utils/ColumnUtils'
import Sortable from 'sortablejs'

export default {
  name: 'DiyInvoiceRemark',
  components: {

  },
  data() {
    return {
      loading: false,
      branchId: null,
      draggingKey: null,
      transferValue: [],
      listData: [],
      rowData: [],
      ifAutoUpdateRemark: false, // 是否自动更新备注
      customRemarkOne: '', // 自定义备注1
      customRemarkTwo: '', // 自定义备注2
      initializationRowData: []
    }
  },
  computed: {
    currentOfficeList() {
      return getUserInfo().currentUserOfficeList
    }
  },
  mounted() {
    this.branchId = this.currentOfficeList[0].officeId
    this.getInitializationConfigFuc()
    this.refreshConfig()

    const transfer = this.$refs.transfer.$el
    const leftPanel = transfer.getElementsByClassName('el-transfer-panel')[0].getElementsByClassName('el-transfer-panel__body')[0]
    const rightPanel = transfer.getElementsByClassName('el-transfer-panel')[1].getElementsByClassName('el-transfer-panel__body')[0]
    const rightEl = rightPanel.getElementsByClassName('el-transfer-panel__list')[0]
    // 右边上下拖拽
    Sortable.create(rightEl, {
      onEnd: (evt) => {
      }
    })
    // 左边拖拽
    leftPanel.ondragover = (ev) => {
      ev.preventDefault()
    }
    leftPanel.ondrop = (ev) => {
      ev.preventDefault()
      const index = this.transferValue.indexOf(this.draggingKey)
      if (index !== -1) {
        this.transferValue.splice(index, 1)
      }
    }
    // 右边拖拽
    rightPanel.ondragover = (ev) => {
      ev.preventDefault()
    }
    rightPanel.ondrop = (ev) => {
      ev.preventDefault()
      const value = this.transferValue
      const key = this.draggingKey
      if (value.indexOf(key) === -1) {
        this.transferValue.push(this.draggingKey)
      }
    }
  },
  methods: {
    // 初始化选中列表
    getInitializationConfigFuc() {
      const self = this
      this.loading = getLoading()
      getInitializationConfig().then(result => {
        self.iList = new Array(result.data)[0]
        const data = []
        for (let i = 0; i <= self.iList.length - 1; i++) {
          data.push({
            key: i,
            label: ColumnUtils.invoiceRemarkLabelFun(self.iList[i])
          })
        }
        this.listData = data
      }).finally(
        self.loading.close()
      )
    },
    // 刷新页面
    refreshConfig() {
      const value = this.branchId
      this.getRemarkConfigFunc(value)
    },
    getRemarkConfigFunc(value) {
      const self = this
      this.loading = getLoading()
      getRemarkConfig(value).then(result => {
        if (result.data !== null) {
          this.transferValue = result.data.list
          this.ifAutoUpdateRemark = result.data.ifAutoUpdateRemark
          this.customRemarkOne = result.data.customRemarkOne
          this.customRemarkTwo = result.data.customRemarkTwo
          // 防止初始化分公司没有默认数据
          if (this.transferValue === undefined) {
            this.transferValue = []
          }
          this.draggingKey = null
        }
      }).finally(
        self.loading.close()
      )
    },
    drag(ev, option) {
      this.draggingKey = option.key
    },
    saveConfig: async function() {
      const self = this
      self.branchId = this.branchId
      const transfer = this.$refs.transfer.$el
      const rightPanel = transfer.getElementsByClassName('el-transfer-panel')[1]
      self.configs = []
      for (let i = 0; i <= this.transferValue.length - 1; i++) {
        const num = rightPanel.getElementsByClassName('el-transfer-panel__item')[i].getElementsByClassName('el-checkbox__original')[0].value
        self.configs.push(Number(num))
      }
      this.loading = getLoading()
      const saveData = { configs: self.configs, branchId: self.branchId, ifAutoUpdateRemark: this.ifAutoUpdateRemark, customRemarkOne: this.customRemarkOne ? this.customRemarkOne.trim() : '', customRemarkTwo: this.customRemarkTwo ? this.customRemarkTwo.trim() : '' }
      saveRemarkConfig(saveData).then(() => {
        this.$message.success(this.$t('SystemMaintenance.SaveSuccess'))
      }).finally(
        self.loading.close()
      )
    }
  }
}
</script>

<style scoped>

ul li{
  list-style: none;
  font-size: 13px;
  color: #909399;
  padding-left: -40px;
}
.app-el-transfer{
  padding-left: 10%;
  padding-bottom: 30px;
}

.app-el-transfer_page{
  width:100%;
}
</style>
